import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

import { reducerGetRoutes, reducerGetRoutesFilters } from "../../reducer/projects/reducers/reducerRoutesListNoModal"
import { reducerGetVacantRoutes, reducerGetRouteList, reducerGetVacantRoutesFilters } from '../../reducer/projects/reducers/reduserVacantRoutesListNoModal'

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetRoutes = (limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    const filter = store.projects.routes.routesInputValues;
    const project = store.projects.projects.currentProject;
    try {
        const response = await axios.post(`${BASE_URL}/json/projects/routes/list`, { limit, page, ...filter, ...project })
        dispatch(reducerGetRoutes({ data: response.data }));
    } catch {
        console.log('err');
    };
}

export const actionGetVacantRoutes = (limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    const id = store.recruiting.singleVacancy.data.vacancy.value.id;
    try {
        const response = await axios.get(`${BASE_URL}/json/projects/vacancy/${id}/routes`);
        dispatch(reducerGetRouteList({ data: response.data.data }));
        dispatch(reducerGetVacantRoutes({ data: response.data }));
    } catch {
      console.log('err');
    };
}

export const actionGetVacantRoutesNoModal = (limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
    dispatch(reducerGetVacantRoutes({ data: [] }));
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    const store = getState();
    let filter = store.projects.vacantRoutesNoModal.vacantRoutesInputValues;
    try {
        const response = await axios.post(`${BASE_URL}/json/projects/routes/list`, { limit, page, ...filter });
        dispatch(reducerGetVacantRoutes({ data: response.data }));
    } catch {
      console.log('err');
    };
}

export const actionGetRoutesFilters = (data: { id: number, name: string }) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
        const response = await axios.post(`${BASE_URL}/json/projects/routes/list/filters`, data)
        dispatch(reducerGetRoutesFilters({ data: response.data }));
        dispatch(reducerGetVacantRoutesFilters({ data: response.data }));
    } catch {
      console.log('err');
    };
}
